'use strict';

Odigeo.defineWidget('xsell_accommodation_results_manager', Odigeo.Widget.extend({
    modelClass: Odigeo.Model.extend(require('./model')),
    viewClass: Odigeo.View.extend(require('./view')),
    update() {
        this.model.update.apply(this.model, arguments);
    },
    showContainer() {
        this.view.showContainer();
    },
    hideContainer() {
        this.view.hideContainer();
    },
    blurDiscountLabels() {
        this.view.blurDiscountLabels();
    },
    handleError(key, remove) {
        this.view.handleError(key, remove);
    },
    hideHotelErrors() {
        this.view.hideHotelErrors();
    },
    handleSelectionAccommodationProductError(args) {
        this.view.handleSelectionAccommodationProductError(args);
    },
    updatePricesAfterRepricing(args) {
        this.view.updatePricesAfterRepricing(args);
    },
    viewAccommodationDetails(details) {
        return this.view.onHotelCardClicked(null, details);
    },
    /**
     * generate hotelData for template
     * @param {AccommodationResult} accommodationResult - the accommodationResultDTO
     * @param {Function} [callback=(data) => data] - callback called with hotelData
     * @return {Object}
     */
    parseAccommodationResult(accommodationResult, callback = (data) => data) {
        return callback(this.view.parse(accommodationResult));
    },
    /**
     * Skips accommodation N results
     * @param {Number} elementsToBeSkipped - element to skip from render
     */
    setElementsToBeSkipped(elementsToBeSkipped = 3) {
        this.view.elementsToBeSkipped = elementsToBeSkipped;
    },
    /**
     *
     * @param {string} key - accommodationDeal key
     * @param {Function} callback - callback
     * @return {AccommodationResult}
     */
    getAccommodationResultFrom(key, callback = (data) => data) {
        const accommodationResult = this.model.get('accommodationResults')
            .find((accommodationResult) => accommodationResult.accommodationDeal.key === key);
        return callback(accommodationResult);
    },
}));
